<template>
<div>
  <v-row class="no-gutters" justify="center" align="center" v-for="(historia , n ) in dataHistorias" :key="'historia-'+n" >
    <v-col cols="12" class="pa-3">
      <div class="cont-noticia">
        <v-row class="no-guters mt-1">
          <v-col cols="12" sm="3" v-if="historia.imagen" class="text-center">
            <div class="cont-img mx-auto">
              <v-img aspect-ratio="1.5" width="100%" :src="$store.state.rutaApi+historia.imagen" ></v-img>
              <!-- <v-btn color="#0B542D" class="mt-2" x-small outlined  @click="openModalH('imagen', n)" >
                <v-icon left>mdi-open-in-new</v-icon> 
              </v-btn> -->
              <div class="cont-ref-img my-1"  v-html="historia.ref_imagen"></div>
              <!-- {{historia.ref_imagen}} -->
            </div>
          </v-col>
          <v-col cols="12" sm="9">
             <p class="ma-0" v-html="historia.texto"></p>
             <v-divider></v-divider>
             <div class="cont-ref-general-his" v-html="historia.ref_general">
             </div>
              <!-- <v-btn color="#0B542D" class="mt-2" small outlined @click="openModalH('texto', n)" >
                <v-icon left>mdi-open-in-new</v-icon>
                 Referencia
              </v-btn> -->
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col cols="12" v-if="(n+1) <= (dataHistorias.length-1)">
      <v-divider class="my-2"></v-divider>
    </v-col>
  </v-row>

  <modal-app v-model="modalRef" :fullscreen="false" width="50vw">
    <template slot="modalcontent">
      <p v-html="contenidoTexto"></p>
    </template>
  </modal-app>


</div>
</template>
<script>
export default {
  props:{
    dataHistorias:[]
  },
  data() {
    return {
      modalRef: false,
      contenidoTexto: null,
    }
  },
  methods: {
    openModalH(tipo, pos){
      this.modalRef = true
      if(tipo == 'texto'){
        this.contenidoTexto = this.dataHistorias[pos].ref_general
      }else{
         this.contenidoTexto = this.dataHistorias[pos].ref_imagen
      }

    }
  },
}
</script>
<style lang="scss" scoped>
.cont-img{
  border: solid 1px #0B542D;
  border-radius: 10px;
  padding: 10px;
}
.cont-noticia{
  // box-shadow: 0 0 10px rgba($color: #000000, $alpha: .4);
  // border: solid 1px #0B542D;
  border-radius: 10px;
  padding: 10px;
  h2{
    font-size: 1.1em;
  }
  p{
    font-size: 1em;
  }
}


</style>